import { useFormContext } from 'react-hook-form'

export const BILLING_METHODS = [
  { value: 'Free of charge', label: 'Free of charge', help: 'This project will not be billed.' },
  {
    value: 'Charge per task type',
    label: 'Charge per task type',
    help: 'Charge clients different hourly rates depending on the type of task performed.'
  },
  {
    value: 'Charge per team member',
    label: 'Charge per team member',
    help: 'Charge clients different hourly rates depending on the team member involved.'
  }
]

/**
 * Presentational only. Renders into the shared FormProvider owned by <Settings>.
 */
const BillingSettings = () => {
  const { register } = useFormContext()

  return (
    <section className="col-lg-11 mt-5">
      <h3>Billing Settings</h3>
      <p>Set how you will bill your client.</p>

      <h4 className="h5 mt-4 mb-2">Billing method</h4>
      <fieldset className="card py-4 px-5">
        <legend className="visually-hidden">Billing method</legend>
        {BILLING_METHODS.map(({ value, label, help }) => {
          const id = `billingMethod-${value.replace(/\s+/g, '-').toLowerCase()}`
          return (
            <div className="form-check mb-3" key={value}>
              <input
                className="form-check-input"
                type="radio"
                id={id}
                value={value}
                {...register('billing_method')}
              />
              <label className="form-check-label" htmlFor={id}>
                {label}
              </label>
              <div className="form-text">{help}</div>
            </div>
          )
        })}
      </fieldset>
    </section>
  )
}

export default BillingSettings
